import mergeClasses from '../../../utils/shallowMerge';
import Button from '../../atoms/button/Button';
import { Text } from '../../typography/text/Text';
import defaultClasses from './AccentBox.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const AccentBox = ({
  background = '#ffffff',
  title = '',
  description = '',
  phoneNumber = '',
  address = '',
  text = '',
  phoneIcon = {},
  adressIcon = {},
  liveChatIcon = {},
  liveChatEnabled = false,
  onOpenChat = () => null,
  placement,
  customClasses,
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);

  return (
    <div
      className={clsx(styles.accentBox, {
        [styles.accentBoxOnAboutUsPage]: placement === 'cmsPages' && placement,
      })}
      style={{
        '--background-color': background ? background : 'inherit',
      }}
    >
      {title && (
        <Text className={styles.accentTitle} as="span" size="xs" weight="semibold">
          {title}
        </Text>
      )}
      {description && (
        <Text className={styles.accentText} as="p" size="xs" weight="light">
          {description}
        </Text>
      )}
      <div className={styles.accentLinkWrapper}>
        <Button
          as="text"
          variant="primary"
          shape="square"
          size="medium"
          href={`tel: ${phoneNumber}`}
          fill="false"
          external={true}
          isOutlined={false}
          isInverted={false}
          className={styles.accentLink}
        >
          {phoneIcon && <img src={phoneIcon.file} alt={phoneIcon.name} className={styles.icon} />}
          {phoneNumber}
        </Button>
        <Button
          as="text"
          variant="primary"
          shape="square"
          size="medium"
          href={`mailto: ${address}`}
          fill="false"
          external={true}
          isOutlined={false}
          isInverted={false}
          className={styles.accentLink}
        >
          {adressIcon && <img src={adressIcon.file} alt={adressIcon.name} className={styles.icon} />}
          {address}
        </Button>
        {liveChatEnabled && (
          <Button
            as="text"
            variant="primary"
            shape="square"
            size="medium"
            fill="false"
            external={true}
            isOutlined={false}
            isInverted={false}
            className={styles.accentLink}
            onClick={onOpenChat}
          >
            {liveChatIcon && <img src={liveChatIcon.file} alt={liveChatIcon.name} className={styles.icon} />}
            {text}
          </Button>
        )}
      </div>
    </div>
  );
};

AccentBox.propTypes = {
  background: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  text: PropTypes.string,
  liveChatEnabled: PropTypes.bool,
  phoneIcon: PropTypes.object,
  adressIcon: PropTypes.object,
  liveChatIcon: PropTypes.object,
  onOpenChat: PropTypes.func,
};

export default AccentBox;
